import { Modal, Flex } from "antd";
import { useTranslation } from "react-i18next";
import useWarningLetter from "../hook/useWarningLetter"
import PendingApprovalWarningLetterTable from "../table/PendingApprovalWarningLetterTable"
import WarningLetterForm from "features/myDocument/components/WarningLetterForm";

const WarningLetter = () => {
    const { t } = useTranslation();
    const props = useWarningLetter()
    const {
        isModalOpen,
        onCloseModal,
        currentWarningLetter,
        modifiedEmployeeOptions,
        modifiedCompanyRegulationOptions,
        onApprove,
        onReject,
    } = props;

    return (
        <>
            <PendingApprovalWarningLetterTable {...props} pageType="view" />

            <Modal
                title={
                    <Flex gap={8}>
                        <span>{t("warning_letter.header") || "หนังสือเตือน"}</span>
                        <span>{currentWarningLetter?.sequence && `(${currentWarningLetter.sequence})`}</span>
                    </Flex>
                }
                open={isModalOpen}
                onCancel={onCloseModal}
                width={987}
                footer={null}
            >
                <WarningLetterForm
                    initialValues={currentWarningLetter}
                    employeeOptions={modifiedEmployeeOptions}
                    companyRegulationOptions={modifiedCompanyRegulationOptions}
                    modalType="view"
                    isApprovalView
                    // onCancel={onCloseModal}
                    onSubmit={() => onApprove(currentWarningLetter)}
                    onReject={() => onReject(currentWarningLetter)}
                />
            </Modal>
        </>
    );
}
export default WarningLetter